import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import TokenCalculator from './components/TokenCalculator';
import Result from './components/Result';
import Footer from './components/Footer';
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { loginRequest } from './authConfig';

function SignInButton() {
  const { instance } = useMsal();
  const handleLogin = () => {
    instance.loginPopup(loginRequest);
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 64 }}>
      <button className="calc-btn" style={{ maxWidth: 220 }} onClick={handleLogin}>
        Sign in with OPTiMO
      </button>
      <div style={{ marginTop: 16, color: '#888', fontSize: '1rem', textAlign: 'center' }}>
        Please sign in with your OPTiMO account to use J.R.R. Token.
      </div>
    </div>
  );
}

function App() {
  const [result, setResult] = useState(null);

  return (
    <div className="app-root">
      <Header />
      <main className="main-content">
        <AuthenticatedTemplate>
          <TokenCalculator onResult={setResult} />
          <Result result={result} />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <SignInButton />
        </UnauthenticatedTemplate>
      </main>
      <Footer />
    </div>
  );
}

export default App;
